<template>
  <div>
    <AppNavigationTop :navigationInfo="AppNavigationTopInfo"/>
    <v-container fluid grid-list-xl>
      <v-layout row fill-height class="mt-4">
        <v-flex xs12 sm8 md6 lg6 xl4 offset-xl4 offset-lg3 offset-md3 offset-sm2>
          <WorkToolDetail/>
        </v-flex>
      </v-layout>
      <v-layout row mb-4>
      </v-layout>
      <v-layout row mb-4>
      </v-layout>
    </v-container>
    <AppNavigationBottom/>
</div>
</template>

<script>
import AppNavigationBottom from "@/frame/navigation/components/AppNavigationBottom";
import AppNavigationTop from "@/frame/navigation/components/AppNavigationTop";
import WorkToolDetail from "@/work/tool/components/WorkToolDetail";
import currentPage from "@/frame/pages/mixins/currentPage.js";
import { mapGetters } from "vuex";
import apptheme from "@/frame/theme/mixins/apptheme.js";

export default {
  components: {
    AppNavigationBottom,
    AppNavigationTop,
    WorkToolDetail
  },
  // eslint-disable-next-line
  mixins: [
    currentPage,
    apptheme
  ],
  data() {
    return {
      currentPagePath: "/worktooldetail"
    };
  },
  computed: {
    // eslint-disable-next-line
    ...mapGetters([
      "getUser",
      "getCurrentPage",
      "getPreviousPage",
      "getSearchResults"
    ]),
    AppNavigationTopInfo() {
      let nav = {
        title: "Work",
        btns: [
          {
            title: "Menu",
            icon: "apps",
            link: "/facilitydash"
          },
          {
            title: "sign out",
            icon: "person_outline",
            link: "/signout"
          }
        ]
      };
      nav.title = "Work Tool";
      nav.btns[0].title = "facility";
      nav.btns[0].icon = "place";
      nav.btns[0].link = "/facilitydash";
      nav.btns[1].title = "maint";
      nav.btns[1].icon = "build";
      nav.btns[1].link = "/facilitydashmaintenance";
      if (this.getSearchResults !== null) {
        let tag = this.getSearchResults[0].basic.tag;
        if (tag === "W1" || tag === "W2") {
          nav.btns[0].title = "work";
          nav.btns[0].icon = "reorder";
          nav.btns[0].link = "/registerlist";
        }
      }
      return nav;
    }
  },
  beforeMount() {
    this.$store.dispatch("changePreviousPage", this.getCurrentPage);
    this.$store.dispatch("changeCurrentPage", this.currentPagePath);
  }
};
</script>
